var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "menu", staticClass: "catalog-menu" },
    [
      _c(
        "div",
        { staticClass: "catalog-menu__head" },
        [
          _c(
            "btn",
            {
              class: [
                "catalog-menu__btn",
                "btn",
                "btn--primary",
                { "catalog-menu__btn--active": _vm.showMenu }
              ],
              attrs: { tag: "control" },
              nativeOn: {
                click: function($event) {
                  _vm.showMenu = _vm.showMenu ? false : true
                }
              }
            },
            [
              _vm._v("\n\t\n\t\t\t" + _vm._s(_vm.filterBtnTitle) + "\n\t\t\t"),
              _vm.selected.length
                ? _c("div", { staticClass: "catalog-menu__btn-count" }, [
                    _vm._v(_vm._s(_vm.selected.length))
                  ])
                : _vm._e(),
              _c(
                "svg",
                {
                  staticClass: "catalog-menu__btn-icon",
                  attrs: { width: "10", height: "10", viewBox: "0 0 10 10" }
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M.5 5.8L4.9 10l4.6-4.3-.7-.7-3.3 3V0h-1v8.2L1.2 5.1z"
                    }
                  })
                ]
              )
            ]
          )
        ],
        1
      ),
      _c(
        "catalog-spoiler",
        { attrs: { noHead: true, noBorder: true, show: _vm.showMenu } },
        [
          _c(
            "div",
            {
              staticClass: "catalog-menu__body",
              attrs: { slot: "body" },
              slot: "body"
            },
            [
              _vm.brands.length
                ? _c(
                    "catalog-spoiler",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "catalog-aside-title",
                          attrs: { slot: "head" },
                          slot: "head"
                        },
                        [_vm._v(_vm._s(_vm.catalogBrandsTitle))]
                      ),
                      _c("catalog-brands", {
                        attrs: { slot: "body", tags: _vm.brands },
                        slot: "body"
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.types.length
                ? _c(
                    "catalog-spoiler",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "catalog-aside-title",
                          attrs: { slot: "head" },
                          slot: "head"
                        },
                        [_vm._v(_vm._s(_vm.catalogTypesTitle))]
                      ),
                      _c("catalog-types", {
                        attrs: { slot: "body", tags: _vm.types },
                        slot: "body"
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.filters.length
                ? _vm._l(_vm.filters, function(nav, index) {
                    return _c(
                      "catalog-spoiler",
                      {
                        key: "catalog-filter-" + index,
                        attrs: { itemsCount: nav.tags.length }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "catalog-aside-title",
                            attrs: { slot: "head" },
                            slot: "head"
                          },
                          [_vm._v(_vm._s(nav.title))]
                        ),
                        _c("catalog-filter", {
                          attrs: { slot: "body", items: nav.tags },
                          slot: "body"
                        })
                      ],
                      1
                    )
                  })
                : _vm._e(),
              _vm.selected.length
                ? _c("div", { staticClass: "catalog-menu__selected" }, [
                    _c("div", { staticClass: "catalog-menu__selected-title" }, [
                      _vm._v(_vm._s(_vm.filterSelectedTitle) + ":")
                    ]),
                    _c(
                      "ul",
                      { staticClass: "catalog-menu__selected-list" },
                      _vm._l(_vm.selected, function(item) {
                        return _c(
                          "li",
                          { staticClass: "catalog-menu__selected-item" },
                          [
                            _c(
                              "btn",
                              {
                                staticClass: "catalog-menu__selected-btn",
                                attrs: { link: item.resetPath }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(item.title) +
                                    "\n\t\t\t\t\t\n\t\t\t\t\t\t\t"
                                ),
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "catalog-menu__selected-btn-icon",
                                    attrs: {
                                      width: "9",
                                      height: "9",
                                      viewBox: "0 0 12 12"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M12 .8l-.8-.8L6 5.2.8 0 0 .8 5.2 6 0 11.2l.8.8L6 6.8l5.2 5.2.8-.8L6.8 6z"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm.selected.length
                ? _c(
                    "btn",
                    {
                      staticClass: "btn btn--outline catalog-menu__reset",
                      attrs: { link: _vm.$route.path }
                    },
                    [_vm._v(_vm._s(_vm.filterResetTitle))]
                  )
                : _vm._e()
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d418b0d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d418b0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CatalogMenu.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4d418b0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/CatalogMenu.vue
// module chunks = 0